import { render } from "./CreateGroupView.vue?vue&type=template&id=52457178&scoped=true"
import script from "./CreateGroupView.vue?vue&type=script&lang=js"
export * from "./CreateGroupView.vue?vue&type=script&lang=js"

import "./CreateGroupView.vue?vue&type=style&index=0&id=52457178&scoped=true&lang=css"

import exportComponent from "/prj/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52457178"]])

export default __exports__